import { PipeTransform } from '@angular/core';
var StatusApprovalsIconPipe = /** @class */ (function () {
    function StatusApprovalsIconPipe() {
    }
    StatusApprovalsIconPipe.prototype.transform = function (statusName) {
        if (statusName) {
            if (statusName === 'pending') {
                return 'access_alarms';
            }
            else if (statusName === 'approved') {
                return 'check_circle';
            }
            else if (statusName === 'refused') {
                return 'timelapse';
            }
            else if (statusName === 'canceled') {
                return 'close';
            }
            else if (statusName === 'new') {
                return 'add_circle_outline';
            }
        }
        return null;
    };
    return StatusApprovalsIconPipe;
}());
export { StatusApprovalsIconPipe };
